import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="110vh"
          w="100%"
          maxHeight="667px"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          alignCenter
          justifyStart
        >
          <Header />
          <CFView textCenter w="100%">
            <CFImage
              w="75%"
              src={mobileHeroText}
              alt="Sushi Ten Victoria hero text"
              zIndex={98}
            />
            <CFView mt="20px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="700px"
          m="0 auto"
          maxWidth="1400px"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyStart
          alignStart
        >
          <Header />
          <CFView column justifyCenter alignStart ml="65px" mt="140px">
            <CFView column justifyStart alignStart>
              <CFImage
                w="580px"
                src={heroText}
                alt="Sushi Ten Victoria hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mv="40px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
